"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventsSequence = void 0;
var lodash_1 = require("lodash");
var single_event_1 = require("./single-event");
/** Серия событий в связанной последовательности */
var EventsSequence = /** @class */function () {
  function EventsSequence(values) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, this.getClassProperties()));
    // преобразование дат
    this.getClassDateProperties().forEach(function (p) {
      if (p in instance && instance[p]) {
        instance[p] = new Date(instance[p]);
      }
    });
    this.events = (values.events || []).map(function (e) {
      return new single_event_1.SingleEvent(e);
    });
  }
  EventsSequence.prototype.getClassProperties = function () {
    return ['begin_at', 'end_at', 'participants_limit', 'participants_left', 'status', 'user_service_id', 'user_service_contract_id', 'account_id', 'meeting_id', 'school_id', 'events'];
  };
  EventsSequence.prototype.getClassDateProperties = function () {
    return ['begin_at', 'end_at'];
  };
  return EventsSequence;
}();
exports.EventsSequence = EventsSequence;
